export const countries = ["Afghanistan","Albania","Algeria","Andorra","Angola","Anguilla","Antigua & Barbuda","Argentina","Armenia","Aruba","Australia","Austria","Azerbaijan","Bahamas","Bahrain","Bangladesh","Barbados","Belarus","Belgium","Belize","Benin","Bermuda","Bhutan","Bolivia","Bosnia & Herzegovina","Botswana","Brazil","British Virgin Islands","Brunei","Bulgaria","Burkina Faso","Burundi","Cambodia","Cameroon","Canada","Cape Verde","Cayman Islands","Chad","Chile","China","Colombia","Congo","Cook Islands","Costa Rica","Cote D Ivoire","Croatia","Cruise Ship","Cuba","Cyprus","Czech Republic","Denmark","Djibouti","Dominica","Dominican Republic","Ecuador","Egypt","El Salvador","Equatorial Guinea","Estonia","Ethiopia","Falkland Islands","Faroe Islands","Fiji","Finland","France","French Polynesia","French West Indies","Gabon","Gambia","Georgia","Germany","Ghana","Gibraltar","Greece","Greenland","Grenada","Guam","Guatemala","Guernsey","Guinea","Guinea Bissau","Guyana","Haiti","Honduras","Hong Kong","Hungary","Iceland","India","Indonesia","Iran","Iraq","Ireland","Isle of Man","Israel","Italy","Jamaica","Japan","Jersey","Jordan","Kazakhstan","Kenya","Kuwait","Kyrgyz Republic","Laos","Latvia","Lebanon","Lesotho","Liberia","Libya","Liechtenstein","Lithuania","Luxembourg","Macau","Macedonia","Madagascar","Malawi","Malaysia","Maldives","Mali","Malta","Mauritania","Mauritius","Mexico","Moldova","Monaco","Mongolia","Montenegro","Montserrat","Morocco","Mozambique","Namibia","Nepal","Netherlands","Netherlands Antilles","New Caledonia","New Zealand","Nicaragua","Niger","Nigeria","Norway","Oman","Pakistan","Palestine","Panama","Papua New Guinea","Paraguay","Peru","Philippines","Poland","Portugal","Puerto Rico","Qatar","Reunion","Romania","Russia","Rwanda","Saint Pierre & Miquelon","Samoa","San Marino","Satellite","Saudi Arabia","Senegal","Serbia","Seychelles","Sierra Leone","Singapore","Slovakia","Slovenia","South Africa","South Korea","Spain","Sri Lanka","St Kitts & Nevis","St Lucia","St Vincent","St. Lucia","Sudan","Suriname","Swaziland","Sweden","Switzerland","Syria","Taiwan","Tajikistan","Tanzania","Thailand","Timor L'Este","Togo","Tonga","Trinidad & Tobago","Tunisia","Turkey","Turkmenistan","Turks & Caicos","Uganda","Ukraine","United Arab Emirates","United Kingdom","United States","Uruguay","Uzbekistan","Venezuela","Vietnam","Virgin Islands (US)","Yemen","Zambia","Zimbabwe"];

export const errorMessages = {
  email: 'Please fill out a correct email address',
  required: 'Please fill out this field'
};

export const customErrorMessages = {
  minLengthPassword: 'Your password must be at least 8 characters long',
  passwordConfirmation: 'Your password confirmation doesn\'t equal the password',
};

export const status = {
  awaitingApproval: 'Awaiting approval',
  inProgress: 'In progress',
  completed: 'Completed',
  canceled: 'Canceled'
};

export const notification = {
  authFailed: 'Login failed',
  userNotActivated: 'User not (yet) activated',
  logout: 'You are now logged out',
  login: 'Welcome to your Morley PRO',
  infoSaved: 'Your information was saved',
  outOfStock: 'Product is out of stock',
  checkout: 'Order successfully created',
  addedToCart: 'Product has been added to your cart',
  duplicateUser: 'User already exists',
  nonExistingUser: 'User not found',
  tokenExpired: 'Your token has expired, please login again'
};

export const label = {
  name: 'Name',
  firstName: 'First name',
  lastName: 'Last name',
  email: 'Email address',
  telephone: 'Telephone number',
  storeName: 'Store name',
  companyName: 'Company name',
  vat: 'VAT-number',
  streetNumber: 'Street & number',
  number: 'Number',
  street: 'Street',
  postalCodeCity: 'Postal code & city',
  postalCode: 'Postal code',
  city: 'City',
  country: 'Country',
  password: 'Password',
  passwordConfirmation: 'Repeat your password',
  address: 'Address'
};

export const data = {
  login: 'Login',
  logout: 'Logout',
  myAccount: 'My account',
  shop: 'Shop',
  myOrders: 'My orders',
  myInformation: 'My information',
  myLatestOrders: 'My latest orders',
  personalAccountInformation: 'Personal & account information',
  invoiceData: 'Invoice data',
  deliveryData: 'Delivery data',
  editInformation: 'Edit information',
  editInvoiceData: 'Edit invoice data',
  editDeliveryData: 'Edit delivery data',
  editOrder: 'Edit order',
  saveOrder: 'Save order',
  saveInformation: 'Save information',
  saveInvoiceData: 'Save invoice data',
  saveDeliveryData: 'Save delivery data',
  selectSize: 'Please select your size',
  orderId: 'Order ID',
  date: 'Date',
  totalPrice: 'Total Price',
  status: 'Status',
  downloadPhotos: 'Download photos',
  downloadPackshots: 'Download packshots',
  downloadExcelFile: 'Download as Excel file',
  downloadLineSheet: 'Download line sheet',
  noAccountYet: 'Don\'t have an account yet?',
  emptyCart: 'Empty cart',
  emptyCartMessage: 'Your cart is empty. Add some products to your shopping cart to place your order.',
  cart: 'Your shopping cart',
  forgotPassword: 'Forgot password?',
  forgotPasswordMessage: 'You forgot your password? No problem, we\'ve got you covered. Please fill out your email address below and we\'ll send you a link to change your password. Please allow a few minutes for the email to arrive.',
  registerMessage: 'To create your account, please fill out the form below. We\'ll have to approve your account. We\'ll then send you an email whenever your account is ready to log in.',
  registerSuccessMessage: 'Thank you for your registration. Once we have approved your account, you\'ll be able to login. We\'ll check your registration as soon as possible and send you an email.',
  requestNewPassword: 'Request new password',
  register: 'Create your account',
  registerSuccess: 'Thank you!',
  createAccount: 'Create account',
  viewAll: 'View all',
  continueShopping: 'Continue shopping',
  checkout: 'Create your order',
  orderCancel: 'Cancel order',
  orderCanceledMessage: 'Your order has been successfully canceled',
  cancelOrderConfirmTitle: 'Cancel order',
  cancelOrderConfirmText: 'Are you sure you wish to cancel this order?',
  lookbook: 'Lookbook',
  silhouettes: 'Silhouettes',
  girls: 'Girls',
  boys: 'Boys',
  shopCollection: 'Shop collection',
  logoutConfirmTitle: 'Logout?',
  logoutConfirmText: 'Are you sure you wish to logout?',
  confirmRemoveFromCartTitle: 'Are you sure?',
  confirmRemoveFromCartText: 'Are you sure you wish to remove this item from your order?',
  forgotPasswordSuccessMessage: 'You will receive an email to request a new password shortly.',
  noOrdersYet: 'You don\'t have any orders yet.',
  viewOrder: 'View order',
  downloadConfirmTitle: 'Just a little reminder',
  noLookbookPhotos: 'No lookbook is available yet, please come back later.',
  noSilhouttePhotos: 'No silhouettes photos available yet, please come back later.',
  noProducts: 'No products are available for this collection and category.',
  error404: 'Not found',
  error404Text: 'We could not find the resource you are looking for. This might be caused by a spelling mistake in the url. It is also possible that you are not logged in.',
  backToHome: 'Back to homepage'
};